export default {
	API_URL: 'http://api-gadocorte.infinitum-ti.com/api',
	OAPI_URL: 'http://api-gadocorte.infinitum-ti.com/oapi',
	// API_URL: 'http://localhost:2376/api',
	// OAPI_URL: 'http://localhost:2376/oapi',
}
